export default "__VITE_ASSET__ef9f18ba__"